import boardAccountsReducer from './boardAccountsReducer';
import boardEntriesReducer from './boardEntriesReducer';
import boardExpensesByCategoryReducer from './boardExpensesByCategoryReducer';
import boardReducer from './boardReducer';
import boardSummaryReducer from './boardSummaryReducer';
import boardTimelineReducer from './boardTimelineReducer';
import categoriesReducer from './categoriesReducer';
import themeSlice from './themeSlice';
import typesReducer from './typesReducer';
import userReducer from './userReducer';

const rootReducer = {
  board: boardReducer,
  boardAccounts: boardAccountsReducer,
  boardEntries: boardEntriesReducer,
  boardExpensesByCategory: boardExpensesByCategoryReducer,
  boardSummary: boardSummaryReducer,
  boardTimeline: boardTimelineReducer,
  categories: categoriesReducer,
  theme: themeSlice,
  types: typesReducer,
  user: userReducer,
};

export default rootReducer;
